import { connect } from 'react-redux';
import { keyBy } from 'lodash/fp';
import playerPositionsSelector from '../../selectors/playerPositionsSelector';
import teamPositionsSelector from '../../selectors/teamPositionsSelector';
import salaryExpenditureSelector from '../../selectors/salaryExpenditureSelector';
import { makeInitials, makePositionStr } from '../../utils/playerUtils';
import OpenEntityRow from './OpenEntityRow';

function mapStateToProps(state, { id, isRacing, isTeam }) {
  const entity = isTeam ? state.challenge.teams[id] : state.challenge.players[id];
  const positions = isTeam ? teamPositionsSelector(state) : playerPositionsSelector(state);
  const { average, form, salary, weight, winProjected, placeProjected, popularity } = entity;

  return {
    awayTeam: entity.awayAbbr,
    barrier: entity.barrier,
    canAfford: entity.salary <= state.challenge.salaryCap - salaryExpenditureSelector(state),
    homeTeam: entity.homeAbbr,
    image: entity.imageURI,
    rider: entity.rider,
    riderImage: entity.riderImage,
    initials: makeInitials(entity.name),
    isHome: !!state.challenge.games.find(g => g.homeId === entity.teamId),
    isRacing,
    isScratched: entity.isScratched,
    labels: entity.labels,
    name: entity.name,
    playerSelectionTableInfo: state.challenge.playerSelectionTableInfo,
    positionStr: makePositionStr(keyBy('id', positions))(entity.positions),
    positions: entity.positions,
    reverseOrder: entity.reverseOrder,
    trainer: entity.trainer,
    tableData: {
      average,
      form,
      salary,
      weight,
      winProjected,
      placeProjected,
      popularity
    },
    teamName: entity.teamName
  };
}

const WidgetEntityRow = connect(mapStateToProps)(OpenEntityRow);

export default WidgetEntityRow;
